"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/search/24.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.searchBar-container {\n  position: relative;\n  width: 100%; }\n  .searchBar-container svg {\n    position: absolute;\n    right: 4px;\n    top: 4px;\n    cursor: pointer; }\n\n@media (max-width: 66rem) {\n  .searchBar-container .searchBar-container .bx--search--sm svg {\n    display: none; } }\n";
  const fileName = "SearchBar_SearchBar";
  const element = document.querySelector("style[data-sass-component='SearchBar_SearchBar']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SearchBar = _ref => {
  let {
    history,
    translate,
    placeholder,
    lang
  } = _ref;
  const [value, setValue] = (0, _react.useState)();
  const searchText = () => {
    value && history.push(`/${lang}/search/${value}`);
  };
  const aux_array = history.location.pathname.split(`/${lang}/search/`);
  const defaultValue = aux_array?.length > 1 ? aux_array.at(-1) : undefined;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "searchBar-container"
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Search, {
    size: 'sm',
    defaultValue: defaultValue,
    placeholder: translate(placeholder),
    labelText: false,
    onChange: e => setValue(e.target.value),
    onKeyDown: e => e.keyCode === 13 && searchText(),
    renderIcon: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.default, {
      onClick: searchText
    }))
  }));
};
var _default = exports.default = SearchBar;